export default __webpack_public_path__ + "static/media/en-linea.aeacc0fe.png";